import React, {
  Component
} from 'react';
import {
  Button,
  Form,
  Grid,
  Menu,
  Modal
} from 'semantic-ui-react';
import {
  includes,
  without
} from 'lodash';

const UsersFilterModal = (props) =>
  <Modal open={props.open} onClose={props.dismissFilters} size="small">
    <Modal.Header>Filtros</Modal.Header>
    <Modal.Content>
      <Grid columns={2}>
        <Grid.Column>
          <Menu fluid vertical tabular>
            <Menu.Item name="roles" active />
          </Menu>
        </Grid.Column>
        <Grid.Column>
          <Form>
            <Form.Checkbox
              label="Administrador" value="admin"
              checked={includes(props.filters.roles, 'admin')}
              onChange={props.changeRolesFilter} />
            <Form.Checkbox
              label="Supervisor" value="supervisor"
              checked={includes(props.filters.roles, 'supervisor')}
              onChange={props.changeRolesFilter} />
            <Form.Checkbox
              label="Operador" value="operator"
              checked={includes(props.filters.roles, 'operator')}
              onChange={props.changeRolesFilter} />
            <Form.Checkbox
              label="Investigador" value="inquirer"
              checked={includes(props.filters.roles, 'inquirer')}
              onChange={props.changeRolesFilter} />
          </Form>
        </Grid.Column>
      </Grid>
    </Modal.Content>
    <Modal.Actions>
      <Button onClick={props.dismissFilters} negative basic>
        Cancelar
      </Button>
      <Button onClick={props.applyFilters} primary>
        Aplicar
      </Button>
    </Modal.Actions>
  </Modal>;

export default UsersFilterModal;


// WEBPACK FOOTER //
// ./client/components/pages/system/UsersFilterModal.js